<script setup>
useHead({
  bodyAttrs: {
    class: 'bg-slate-50 dark:bg-slate-800'
  }
})
</script>

<template lang="pug">
NuxtLayout(name="empty")
  div
    WebHeader
    slot
    WebFooter
</template>
